import { render, staticRenderFns } from "./dataDictionarySon.vue?vue&type=template&id=7d8698d6&scoped=true&"
import script from "./dataDictionarySon.vue?vue&type=script&lang=js&"
export * from "./dataDictionarySon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8698d6",
  null
  
)

export default component.exports